import { Device } from "@/__generated__/graphql";
import { Grid } from "@mui/material";
import { Control } from "react-hook-form";
import { FormValues } from 'src/features/createDeviceConfiguration/type/FormValues';
import NormalDeviceForm from "./NormalDeviceForm";
import LGDeviceForm from "./LGDeviceForm";
import useHardwareOptions from "@features/createDeviceConfiguration/hooks/useHardwareOptions";
import DeviceSensorsForm from "./DeviceSensorsForm";


interface SensorizationTabContentProps {
  device: Device;
  control: Control<FormValues>;
  sensorLevel: any;
  sensorVelocity: any;
  sensorFlow: any;
  sensorAngle: any;
}

const SensorizationTabContent = ({
  device,
  control,
  sensorLevel,
  sensorVelocity,
  sensorFlow,
}: SensorizationTabContentProps) =>   {
  const isLGDevice = device.profile?.type?.includes('LG');

  const { options: sensorLevelOptions } = useHardwareOptions('level_sensor');
  const { options: sensorVelocityOptions } = useHardwareOptions('velocity_sensor');
  const { options: sensorFlowOptions } = useHardwareOptions('flow_sensor');
  const { options: sensorAngleOptions } = useHardwareOptions('angle_sensor');

  const parentDevice = device?.relatedDevices?.find(rel => rel.relation === 'PARENT')?.device;
  const isChildDevice = !!parentDevice;

  return (
    <Grid item xs={12} sm={8} p={2} mt={2}>
      {isChildDevice ? (
        <DeviceSensorsForm
          device={device}
          control={control}
        />
      ) : (
        !isLGDevice ? (
          <NormalDeviceForm
            device={device}
            control={control}
            sensorLevelOptions={sensorLevelOptions}
            sensorVelocityOptions={sensorVelocityOptions}
            sensorFlowOptions={sensorFlowOptions}
            sensorLevel={sensorLevel}
            sensorVelocity={sensorVelocity}
            sensorFlow={sensorFlow}
          />
        ) : (
          <LGDeviceForm
            device={device}
            control={control}
            sensorLevelOptions={sensorLevelOptions}
            sensorAngleOptions={sensorAngleOptions}
          />
        )
      )}
    </Grid>
  );
};

export default SensorizationTabContent;
